import "./styles.scss";
import ClayForm, { ClayInput, ClaySelect } from "@clayui/form";
import ClayIcon from '@clayui/icon';
import React, {useEffect, useState} from "react";
import { getPathName } from "../../utils/utilsFunc";
import HeaderSearchContextProvider, {
    HeaderSearchContext,
    ACTIONS
} from "../../context/HeaderSearchProvider";
import { CGE } from "../CGE";

function HeaderSearch({ data, setSearch, setSelected, idClient, inputSearch }) {
  const [state, dispatch] = React.useContext(HeaderSearchContext)
  const [firstSelected, setFirstSelected] = useState('')
  const [detailClient, setDetailClient] = useState('')
  const [localId, setLocalId] = useState('')
  const [orderData, setOrderData] = useState([])
  let optionsFilterSelect = []
  let classCalle = null;

  useEffect(() => {
    if(Array.isArray(data) && data?.length > 0 ) {
      setOrderData(data?.sort((a, b) => a - b));
    }
  },[data])

  if(getPathName() === 'pagos-realizados' || getPathName() === 'cartola-de-compensacion' || getPathName() ===  'cartola-de-reliquidacion-y-compensacion' || getPathName() === 'deuda-actual-y-vencida' || getPathName() === 'cartola-de-reliquidacion' || getPathName() === 'convenio-de-pago' || getPathName() === 'emision-certificado-de-deuda'  || getPathName() === 'emision-certificado-de-dotacion'  || getPathName() === 'emision-certificado-deuda-dotacion' || getPathName() === 'consulta-medidores-inteligentes'){

    optionsFilterSelect = [{
      label: "Seleccione un Cliente",
      value: '',
    },];
    orderData.forEach((id) => {
      optionsFilterSelect.push({ label: id, value: id });
    });
  } else if(getPathName() === 'saldo-actual' || getPathName() === 'estado-del-servicio' || getPathName() === 'suscripciones'|| getPathName() === 'clientes-asociados') {
    optionsFilterSelect = [{
      label: "Todos los clientes seleccionados",
      value: '',
    },];
    orderData?.forEach((id) => {
      optionsFilterSelect.push({ label: id, value: id });
    });
  } else if(getPathName() === 'boleta-y-anexo-netbilling') {
    optionsFilterSelect = [{
      label: "Seleccione un cliente",
      value: '',
    },];
    orderData.forEach((id) => {
      optionsFilterSelect.push({ label: id, value: id });
    });
  } else {
    orderData.forEach((col) => {
      optionsFilterSelect.push({ label: col.id_client, value: col.id_client });
    });
  }
  

  useEffect(() => {

      if(["boleta-y-anexo-netbilling", "pagos-realizados", "cartola-de-compensacion", "cartola-de-reliquidacion-y-compensacion", "cartola-de-reliquidacion", "deuda-actual-y-vencida","consulta-medidores-inteligentes"].includes(getPathName())) {
        optionsFilterSelect.map((item) => {
          if(orderData && item.value === optionsFilterSelect[1]?.value && !firstSelected){
            setFirstSelected(item.value)
            setLocalId(item.value);
            setSelected(optionsFilterSelect[1]?.value)
          }
        })
      }
        
  },[orderData]);

  function handleChange(e) {
    setDetailClient('');
    setSelected(e.target.value)
    setLocalId(e.target.value)
  }
  function setSearchAux(e) {
    setLocalId(e);
    setSearch(e);
  }

  useEffect(() => {
    if(localId){
      let booleanVerif = Object.values(optionsFilterSelect).find((obj) => {
        return obj.value === localId
      });

      if(booleanVerif){
        dispatch({
            payload: booleanVerif.value,
            type: ACTIONS.SET_CTA_CTO,
        })
      }
    }
  }, [localId]);

  useEffect(() => {
    classCalle.refs.input.className = 'autofocus-style'
  }, []);

  useEffect(() => {
    if(state.detailClient){
      setDetailClient(state?.detailClient?.ConsultarDetalleCtaCtoResponse?.ITEM);
    }
  }, [state.detailClient]);
  

  useEffect(() => {
    const storedState = JSON.parse(sessionStorage.getItem("state"));
    if(storedState && storedState.idCtaCto !== 0 && getPathName() === 'boleta-y-anexo-netbilling'){
      setSelected(storedState.idCtaCto)
      setFirstSelected(storedState.idCtaCto)
    }
  }, [])

  return (
    <>
      <div id="search-bar" >
        <div className="select-client-content">
          <label htmlFor="mySelectId" className="client-label">
            Nº Cliente
          </label>
          <ClayForm.Group 
          >
            <ClaySelect
              className="search-input"
              id="mySelectId"
              label="Selecione"
              onChange={(e) => handleChange(e)}
            >
              {optionsFilterSelect[1]?.value ? optionsFilterSelect.map((item) => (
                <ClaySelect.Option
                  key={item.value}
                  label={item.label}
                  value={item.value}
                  selected={item.value === firstSelected}
                />
              )):
              !idClient && optionsFilterSelect.map((item) => (
                <ClaySelect.Option
                  key={item.value}
                  label={item.label}
                  value={item.value}
                />))
              }
            </ClaySelect>
          </ClayForm.Group> 
        </div>

        <div className="search-content">
          <ClayIcon symbol="search" className="search-icon" />
          <CGE.FormsField
          horizontalAutocomplete={true}
          inputProps={{ id: 'basicInputText' }}
          handleChange={(e) => setSearchAux(e.target.value)}
          autocomplete={true}
          atcGetItemValue={item => item}
          atcItems={orderData}
          placeholder="Numero de Cliente"
          atcMenuStyle={inputSearch && {
              borderRadius: '5px',
              border: '1px solid #a8a8a8',
              boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
              background: '#fff',
              fontSize: '15px',
              fontWeight: 'normal',
              left: '0',
              maxHeight: '300px',
              overflow: 'auto',
              padding: '0 0',
              position: 'absolute',
              top: '40px',
              zIndex: '1'
          }}
            atcOnChange={(e) => setSearchAux(e.target.value)}
            atcOnSelect={(val) => setSearchAux(val)}
            atcRef={el => classCalle = el}
            atcRenderItem={
                (item, highlighted) =>
                    <div
                        className="street-options pl-3 "
                        style={
                            {
                                backgroundColor: highlighted ? '#00a7e1' : '#fff',
                                color: highlighted ? '#fff' : '#000000',
                            }
                        }
                    >
                        {item}
                        
                    </div>
            }
            atcShouldItemRender={(item, value) => item?.toLowerCase().indexOf(value?.toLowerCase()) !== -1 && value}
            atcValue={inputSearch}
            atcWrapperStyle={{ display: 'block' }}

        />
          <p className="search-label">
            búsqueda
          </p>
        </div>        
      </div>
      {detailClient &&
        <div id="search-bar" className="mt-n3">
          <div> Dirección: {detailClient.CALLE} {detailClient.NUMERO_CASA} {detailClient.EDIFICIO} {detailClient.COMUNA}</div>
        </div>
      }
    </>
  );
}

const HeaderSearchWithProvider = ({ data, setSearch, setSelected, idClient, inputSearch }) => (
    <HeaderSearchContextProvider>
        <HeaderSearch data={data} setSearch={setSearch} inputSearch={inputSearch} setSelected={setSelected} idClient={idClient} />
    </HeaderSearchContextProvider>
);
export default HeaderSearchWithProvider;
